import React from 'react';

import { Button } from '@material-ui/core';

import InputField from '../../common/components/inputField';
import classes from '../../css/getCSS';


const loginForm = (props) => {
  return (
    <React.Fragment>
      <InputField
        id="email"
        config={props.inputs.email}
        changed={event => props.inputChangedHandler(event, 'email')}
      />
      <br />
      <Button variant="contained" color="primary" type="submit" size="large" className={classes.Button}>
        Submit
      </Button>
    </React.Fragment>
  );
};

export default loginForm;



// WEBPACK FOOTER //
// ./src/auth/components/PasswordResetForm.js